import React from "react";
import "./History_Vendor.css";
import Common_History_Vendor from "../../../common_components/common-history-vendor/Common_History_Vendor";

const vendors = [
  {
    id: 1,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 2,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 3,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 1,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 2,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 3,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 1,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 2,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 3,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 1,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 2,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
  {
    id: 3,
    detailsId: "#ORD12345",
    vendor: "Abhisheks woods",
    date: "12 July 2025",
    time: "12:40PM",
    image: "/assets/images/vendors/vendor3.png",
  },
];

function History_Vendor({ vendorexpertlist }) {
  const historyData = vendorexpertlist?.data || [];

  return (
    <div className="container mt-4 history-section">
      <div className="row">
        {historyData.length ? (
          historyData.map((item) => (
            <div key={item.id} className="col-12 col-md-6 col-lg-4 mb-4">
              <Common_History_Vendor data={item} />
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p className="text-muted">No data found</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default History_Vendor;
